import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Shield } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await axios.post(
        `${BACKEND_URL}/api/admin/login`,
        { username, password },
        { withCredentials: true }
      );
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F1EA] p-6">
      <div className="w-full max-w-md">
        <div className="bg-white border border-[#0A0A0A]/10 rounded-2xl p-8 shadow-xl">
          <div className="text-center mb-8">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-[#B8935A]/20 flex items-center justify-center">
              <Shield className="w-8 h-8 text-[#B8935A]" />
            </div>
            <h1 className="text-3xl font-bold text-[#0A0A0A] mb-2">Admin Panel</h1>
            <p className="text-[#525252]">Sol Digital Management</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-5">
            <div>
              <Label htmlFor="username" className="text-[#0A0A0A] mb-2 block">Username</Label>
              <Input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter username"
                className="bg-white border-[#0A0A0A]/15 text-[#0A0A0A] rounded-xl h-12"
                data-testid="admin-username-input"
                required
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-[#0A0A0A] mb-2 block">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                className="bg-white border-[#0A0A0A]/15 text-[#0A0A0A] rounded-xl h-12"
                data-testid="admin-password-input"
                required
              />
            </div>

            {error && (
              <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-3">
                <p className="text-red-400 text-sm text-center">{error}</p>
              </div>
            )}

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#0A0A0A] hover:bg-[#1a1a1a] text-white rounded-xl h-12 font-semibold"
              data-testid="admin-login-button"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
